import React from 'react';
import { ITeamLeadFilters, enumMapping } from './interface';
import {
  Directions,
  Tooltip as TooltipV2,
  TooltipContent,
  TooltipTrigger
} from '../../components/TooltipV2/TooltipV2';
import styles from './TeamLead.module.scss';
import { CancelIcon } from '@navi/web-ui/lib/icons';

interface ISelectedFilterItem {
  filters: ITeamLeadFilters;
  filterKey: string;
  label: string;
  selectedFilters: string;
  removeSelectedFilter: (filterKey: string) => void;
}

const SelectedFilterItem: React.FC<ISelectedFilterItem> = ({
  filters,
  filterKey,
  label,
  selectedFilters,
  removeSelectedFilter
}) => {
  const filtersSelected = selectedFilters?.split(',');
  const countFilter = filtersSelected?.length;
  const selectedOptions = filters[filterKey as keyof typeof filters];
  const isArray = Array.isArray(selectedOptions);
  const selectedFiltersLabel = filtersSelected?.map((filter: string) => {
    const dataDisplayMapping = enumMapping[filterKey as keyof typeof enumMapping];
    const label = isArray
      ? dataDisplayMapping?.[filter as keyof typeof dataDisplayMapping]
      : selectedOptions?.[filter] + '';
    return label;
  });

  return (
    <TooltipV2 placement={Directions.BOTTOM} key={filterKey}>
      <TooltipTrigger className={styles.cashCollectedTooltipTriggerWrapper}>
        <div className={styles.selectedFilters}>
          {label}
          <span className="ml-1">({countFilter})</span>
          <CancelIcon onClick={() => removeSelectedFilter(filterKey)} className="ml-1" />
        </div>
      </TooltipTrigger>
      <TooltipContent className={'tooltipWrapper'}>
        {selectedFiltersLabel.join(', ')}
      </TooltipContent>
    </TooltipV2>
  );
};

export default SelectedFilterItem;
